import { T } from '../tema';

export const RAEKKEFOELGE = ["menu","dashboard","klienter","ny-klient","import","import-onedrive","søg","infoskærm","indstillinger","min-profil"];

export const STATUS_FARVE2 = { kritisk:T.roed, aktiv:T.turkis, lead:"#60a5fa", venter:"#f59e0b", lukket:"rgba(255,255,255,0.3)" };

export const deadline_kant_farve = (sag) => {
  if (!sag.deadline) return "#475569"; // grå — ingen deadline
  const dage = Math.ceil((new Date(sag.deadline) - new Date()) / 86400000);
  if (dage <= 0) return "#ff6b6b"; // rød — overskredet eller i dag
  if (dage <= 7) return "#ffd43b"; // gul — 1-7 dage
  return "#69db7c"; // grøn — 7+ dage
};

export const er_kritisk = (sag) => {
  if (!sag.deadline) return false;
  return Math.ceil((new Date(sag.deadline) - new Date()) / 86400000) <= 0;
};
